// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — index.classic.js, новая — index.cp.js
import { isCp } from 'libs/design';
import * as classic from './index.classic';
import * as cp from './index.cp';

export const AddContact = isCp ? cp.AddContact : classic.AddContact;
export const AddRfid = isCp ? cp.AddRfid : classic.AddRfid;
export const BlueButton = isCp ? cp.BlueButton : classic.BlueButton;
export const BlueSaveButton = isCp ? cp.BlueSaveButton : classic.BlueSaveButton;
export const Button = isCp ? cp.Button : classic.Button;
export const CloseButton = isCp ? cp.CloseButton : classic.CloseButton;
export const CreateNew = isCp ? cp.CreateNew : classic.CreateNew;
export const Cross = isCp ? cp.Cross : classic.Cross;
export const GrayButton = isCp ? cp.GrayButton : classic.GrayButton;
export const RedButton = isCp ? cp.RedButton : classic.RedButton;
export const RfidCancel = isCp ? cp.RfidCancel : classic.RfidCancel;
export const SaveButton = isCp ? cp.SaveButton : classic.SaveButton;
export const SubmitButton = isCp ? cp.SubmitButton : classic.SubmitButton;
export const ToOperationsButton = isCp ? cp.ToOperationsButton : classic.ToOperationsButton;
